import { render, staticRenderFns } from "./RegionFormModal.vue?vue&type=template&id=293186da&"
import script from "./RegionFormModal.vue?vue&type=script&lang=js&"
export * from "./RegionFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports